module.exports = __webpack_public_path__ + "media/images/classpoints/brands/BFT-c69cec1a05764cd851887ed970a4f97f.svg";